import { useState, useEffect } from "react";
import { Modal, Button, Card } from "react-bootstrap";
import axios from "axios";
import toastr from "toastr";
import { CustomDropdown } from "components/CustomDropdown";
import { Line } from "ktm-ui";

const BulkEditEmployeeBenCatFixedCampaignModal = ({
    showBulkEditEmployeeBenCatFixedCampaignModal,
    bencatOptions,
    policyId,
    employeeIds,
    closeBulkEditEmployeeBenCatFixedCampaignModal
}) => {
    const [selectedBenCat, setSelectedBenCat] = useState(null);
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        if (bencatOptions?.length) {
            setSelectedBenCat(bencatOptions[0]);
        }
    }, [bencatOptions]);

    const handleSave = async () => {
        if (!selectedBenCat) {
            toastr.error("Please select a benefit category");
            return;
        }

        setSaving(true);

        try {
            const body = {
                PolicyId: policyId,
                EmployeeIds: employeeIds,
                SelectedBenCatId: selectedBenCat.id
            };

            const response = await axios.put(
                "/api/Flex/updateemployeebencatcampaign",
                body
            );

            if (response.data.success) {
                toastr.success("Employees updated successfully");
                closeBulkEditEmployeeBenCatFixedCampaignModal();
            } else {
                toastr.error(response.data.message ?? "Update failed");
            }
        } catch {
            toastr.error("Failed to update employee campaigns");
        } finally {
            setSaving(false);
        }
    };

    return (
        <Modal
            show={showBulkEditEmployeeBenCatFixedCampaignModal}
            onHide={closeBulkEditEmployeeBenCatFixedCampaignModal}
            backdrop="static"
            className="edit-employee-campaign-modal-container"
        >
            <Modal.Header className="campaign-edit-employee-modal-header">
                <Modal.Title>Edit Employee New Year Benefits</Modal.Title>
            </Modal.Header>

            <Modal.Body className="campaign-edit-employee-modal-body">
                <Card>
                    <Line>
                        <div className="RT-TextBox">
                            <label className="RT-Label">Benefit Category</label>

                            <CustomDropdown
                                options={bencatOptions.map(b => b.name)}
                                selectedOption={selectedBenCat?.name}
                                setSelectedOption={(name) =>
                                    setSelectedBenCat(
                                        bencatOptions.find(b => b.name === name)
                                    )
                                }
                            />
                        </div>
                    </Line>
                </Card>
            </Modal.Body>

            <Modal.Footer className="campaign-edit-employee-modal-footer">
                <Button
                    variant="secondary"
                    onClick={closeBulkEditEmployeeBenCatFixedCampaignModal}
                    disabled={saving}
                >
                    Cancel
                </Button>

                <Button
                    variant="primary"
                    onClick={handleSave}
                    disabled={saving || !selectedBenCat}
                >
                    {saving ? "Saving..." : "Save"}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default BulkEditEmployeeBenCatFixedCampaignModal;
